import axios from "axios";
import API_BASE_URL from "@/config/api";

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  mutations: {
    SET_LIST(state, data) {
      state.list = data;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },

  actions: {
    // 🟢 CREATE
    async add({ dispatch }, coffee) {
      await this._vm.$guard.confirmAndExecute({
        message: "Ajouter ce café au stock ?",
        action: async () => {
          const record = { ...coffee, date: coffee.date || new Date().toISOString().split('T')[0] };
          await axios.post(`${API_BASE_URL}/coffee.php`, record);
          await dispatch("fetch");
        },
      });
    },

    // 🔵 READ
    async fetch({ commit }) {
      commit("SET_LOADING", true);
      try {
        const { data } = await axios.get(`${API_BASE_URL}/coffee.php`);
        commit("SET_LIST", data);
      } catch (err) {
        console.error("Erreur fetch coffee:", err);
      }
      commit("SET_LOADING", false);
    },

    // 🟠 UPDATE
    async update({ dispatch }, { id, payload }) {
      await this._vm.$guard.confirmAndExecute({
        message: "Modifier cet enregistrement de café ?",
        action: async () => {
          await axios.put(`${API_BASE_URL}/coffee.php`, { id, ...payload });
          await dispatch("fetch");
        },
      });
    },

    // 🔴 DELETE
    async remove({ dispatch }, id) {
      await this._vm.$guard.confirmAndExecute({
        message: "Supprimer cet élément du stock ?",
        action: async () => {
          await axios.delete(`${API_BASE_URL}/coffee.php`, { data: { id } });
          await dispatch("fetch");
        },
      });
    },

    // ⚪ CLEAR ALL
    async clear({ dispatch }) {
      await this._vm.$guard.confirmAndExecute({
        message: "Effacer tout le stock de café ?",
        action: async () => {
          await axios.post(`${API_BASE_URL}/coffee.php`, { action: "clear" });
          await dispatch("fetch");
        },
      });
    },
  },

  getters: {
    all: (state) => state.list,
    totalQuantity: (state) =>
      state.list.reduce((sum, c) => sum + Number(c.quantite || 0), 0),
    isLoading: (state) => state.loading,
  },
};
